import { PRUEFPUNKTE, type Geraeteklasse } from '../../shared/pruefpunkte.js';
import { modus } from '../api.js';
import { ersetze, h, statusMarke } from '../dom.js';
import { anmeldungAbgelehnt, ereignisse, ergebnisVon, wartendeErgebnisse } from '../ergebnisse.js';
import { erkenneKlasse } from '../geraet.js';
import type { Ansicht } from '../router.js';
import { lies } from '../speicher.js';
import { formatiereZeitpunkt } from '../zeit.js';
import { Aufraeumer } from './gemeinsam.js';

export const start: Ansicht = async (ziel) => {
  const aufraeumer = new Aufraeumer();
  const name = (await lies('name')) ?? 'Unbenannt';
  const klasse: Geraeteklasse = (await lies('klasse')) ?? erkenneKlasse();
  const hinweise = h('div', { class: 'hinweise' });
  const gruppenBereich = h('div', { class: 'gruppen' });

  const zeichneHinweise = async () => {
    const wartend = await wartendeErgebnisse();
    ersetze(
      hinweise,
      klasse === 'handy' &&
        modus() === 'browser' &&
        h(
          'a',
          { href: '/pruefung/installation', class: 'karte hinweis verweis' },
          h('strong', {}, 'Läuft im Browser, nicht als App.'),
          ' Die meisten Prüfungen gelten für die installierte App. Zur Anleitung',
          h('span', { 'aria-hidden': 'true' }, ' →'),
        ),
      anmeldungAbgelehnt() &&
        h(
          'a',
          { href: '/einrichtung', class: 'karte hinweis verweis' },
          h('strong', {}, 'Der Server kennt dieses Gerät nicht mehr.'),
          ' Wartende Ergebnisse gehen erst nach dem erneuten Einrichten hinaus. Gerät neu einrichten',
          h('span', { 'aria-hidden': 'true' }, ' →'),
        ),
      wartend > 0 && h('p', { class: 'karte hinweis', role: 'status' }, `${wartend} Ergebnis${wartend === 1 ? '' : 'se'} noch nicht gesendet. Sie gehen hinaus, sobald der Server erreichbar ist.`),
    );
  };

  const zeichneGruppen = () => {
    const passend = PRUEFPUNKTE.filter((p) => p.klassen.includes(klasse));
    const gruppen = [...new Set(passend.map((p) => p.gruppe))];
    ersetze(
      gruppenBereich,
      ...gruppen.map((gruppe) =>
        h(
          'section',
          { class: 'gruppe', 'aria-label': gruppe },
          h('h2', {}, gruppe),
          h(
            'ul',
            { class: 'pruefliste' },
            ...passend
              .filter((p) => p.gruppe === gruppe)
              .map((p) => {
                const e = ergebnisVon(p.key);
                return h(
                  'li',
                  {},
                  h(
                    'a',
                    { href: `/pruefung/${p.ansicht}#${p.key}`, class: 'pruefzeile' },
                    h('span', { class: 'pruefzeile-titel' }, p.titel, p.iphone && h('span', { class: 'etikett' }, 'vor allem iPhone')),
                    statusMarke(e?.status ?? 'offen'),
                    e && h('span', { class: 'pruefzeile-text' }, e.text),
                    e && h('span', { class: 'pruefzeile-zeit' }, formatiereZeitpunkt(e.erfasstAm)),
                  ),
                );
              }),
          ),
        ),
      ),
    );
  };

  ziel.append(
    h('h1', {}, 'Gerätetest'),
    h('p', { class: 'einleitung' }, h('strong', {}, name), ` · ${modus() === 'app' ? 'installierte App' : 'Browser'} · ${klasse === 'handy' ? 'Handy oder Tablet' : 'PC'}`),
    hinweise,
    gruppenBereich,
    h(
      'nav',
      { class: 'karte fusszeile', 'aria-label': 'Weitere Seiten' },
      h('a', { href: '/auswertung' }, 'Auswertung aller Geräte'),
      h('a', { href: '/druck' }, 'QR-Aufkleber drucken'),
      h('a', { href: '/einrichtung' }, 'Gerät neu einrichten'),
    ),
  );
  await zeichneHinweise();
  zeichneGruppen();
  aufraeumer.hoere(ereignisse, 'geaendert', () => {
    zeichneGruppen();
    void zeichneHinweise();
  });
  return aufraeumer.alles;
};
